"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.Competitor = void 0;
const flatbuffers = require("flatbuffers");
const competitor_qualifier_js_1 = require("../../sportsbook/actual/competitor-qualifier.js");
class Competitor {
    bb = null;
    bb_pos = 0;
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsCompetitor(bb, obj) {
        return (obj || new Competitor()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsCompetitor(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new Competitor()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    id() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint32(this.bb_pos + offset) : 0;
    }
    name(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    state() {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.readInt8(this.bb_pos + offset) : 1;
    }
    qualifier() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.readInt8(this.bb_pos + offset) : competitor_qualifier_js_1.CompetitorQualifier.home;
    }
    abbreviation(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    countryCode(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    imageSmall(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 16);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    imageMedium(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 18);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    imageBig(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 20);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    static startCompetitor(builder) {
        builder.startObject(9);
    }
    static addId(builder, id) {
        builder.addFieldInt32(0, id, 0);
    }
    static addName(builder, nameOffset) {
        builder.addFieldOffset(1, nameOffset, 0);
    }
    static addState(builder, state) {
        builder.addFieldInt8(2, state, 1);
    }
    static addQualifier(builder, qualifier) {
        builder.addFieldInt8(3, qualifier, competitor_qualifier_js_1.CompetitorQualifier.home);
    }
    static addAbbreviation(builder, abbreviationOffset) {
        builder.addFieldOffset(4, abbreviationOffset, 0);
    }
    static addCountryCode(builder, countryCodeOffset) {
        builder.addFieldOffset(5, countryCodeOffset, 0);
    }
    static addImageSmall(builder, imageSmallOffset) {
        builder.addFieldOffset(6, imageSmallOffset, 0);
    }
    static addImageMedium(builder, imageMediumOffset) {
        builder.addFieldOffset(7, imageMediumOffset, 0);
    }
    static addImageBig(builder, imageBigOffset) {
        builder.addFieldOffset(8, imageBigOffset, 0);
    }
    static endCompetitor(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createCompetitor(builder, id, nameOffset, state, qualifier, abbreviationOffset, countryCodeOffset, imageSmallOffset, imageMediumOffset, imageBigOffset) {
        Competitor.startCompetitor(builder);
        Competitor.addId(builder, id);
        Competitor.addName(builder, nameOffset);
        Competitor.addState(builder, state);
        Competitor.addQualifier(builder, qualifier);
        Competitor.addAbbreviation(builder, abbreviationOffset);
        Competitor.addCountryCode(builder, countryCodeOffset);
        Competitor.addImageSmall(builder, imageSmallOffset);
        Competitor.addImageMedium(builder, imageMediumOffset);
        Competitor.addImageBig(builder, imageBigOffset);
        return Competitor.endCompetitor(builder);
    }
}
exports.Competitor = Competitor;
